export const namespaced = true;

export const state = {
    meetingInfo: null,
    meetingProfileSet: false,
    meetingSurveySet: false,
    meetingAirportSelected: null,
}

export const mutations = {
    OPT_OUT_FLIGHT(state, payload){
        state.meetingInfo.noAirTravelRequired = payload;
        this.state.bookTravel.result.flight = {};
    },
    OPT_OUT_CAR(state, payload){
        state.meetingInfo.noCarRentalRequired = payload;
        this.state.bookTravel.result.car = {};
    },
    OPT_OUT_HOTEL(state, payload){
        state.meetingInfo.noHotelRequired = payload;
        this.state.bookTravel.result.hotel = {};
    },
    ADD_MEETING(state, payload){
        state.meetingInfo = payload;
    },
    ADD_MEETING_RECORD_LOCATOR(state, payload){
        state.meetingInfo.pnrRecordLocator = payload;
    },
    ADD_MEETING_PROFILE(state, payload){
        state.meetingInfo.contact = payload;
    },
    MEETING_PROFILE_SET(state, payload){
        state.meetingProfileSet = payload;
    },
    MEETING_SURVEY_SET(state, payload){
        state.meetingSurveySet = payload;
    },
    ALTER_MEETING_AIRPORT_SELECTED(state, payload){
        state.meetingAirportSelected = payload;
    },
    ADD_PAYMENT_TO_MEETING_CONTACT(state, payload) {
        state.meetingInfo.contact.paymentMethods.push(payload);
    },
    UPDATE_PAYMENT_TO_MEETING_CONTACT(state, payload) {

        const paymentMethods = state.meetingInfo.contact.paymentMethods;
        const index = paymentMethods.findIndex(method => method.id === payload.id);
      
        if (index !== -1) {
          // Update the existing payment method
          paymentMethods[index] = { ...paymentMethods[index], ...payload };
        } 
    },
}

export const actions = {
    addMeeting(context, payload){
        context.commit('ADD_MEETING', payload);
    },
    addMeetingRecordLocator(context, payload){
        context.commit('ADD_MEETING_RECORD_LOCATOR', payload);
    },
    optOutFlight(context, payload){
        context.commit('OPT_OUT_FLIGHT', payload);
    },
    optOutCar(context, payload){
        context.commit('OPT_OUT_CAR', payload);
    },
    optOutHotel(context, payload){
        context.commit('OPT_OUT_HOTEL', payload);
    },
    addMeetingProfile(context, payload){
        context.commit('ADD_MEETING_PROFILE', payload);
    },
    meetingProfileSet(context, payload){
        context.commit('MEETING_PROFILE_SET', payload);
    },
    meetingSurveySet(context, payload){
        context.commit('MEETING_SURVEY_SET', payload);
    },
}

export const getters = {}